import { render, staticRenderFns } from "./VIconPrev.vue?vue&type=template&id=710d4648&scoped=true&"
import script from "./VIconPrev.vue?vue&type=script&lang=ts&"
export * from "./VIconPrev.vue?vue&type=script&lang=ts&"
import style0 from "./VIconPrev.vue?vue&type=style&index=0&id=710d4648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710d4648",
  null
  
)

export default component.exports